import { useState, useEffect } from "react"
import axios from "axios"
import { extendTheme } from "@chakra-ui/react"
import defaultTheme from "./default-theme"

function useThemes() {
  let theme_ = {}
  let theme_name = process.env.THEME_ID

  try {

    const theme_config = JSON.parse(process.env.THEME_CONFIG)

    //If the theme object is not empty extend the theme configuration 
    if (Object.keys(theme_config).length != 0) {
      theme_ = extendTheme({
        ...theme_config,
        styles: {
          global: {
            body: {
              fontFamily: null,
              lineHeight: null,
              fontSize: null,
              fontColor: null,
              fontWeight: null,
            }
          }
        }
      })
    } else {
      theme_ = extendTheme({
        ...defaultTheme,
        styles: {
          global: {
            body: {
              fontFamily: null,
              lineHeight: null,
              fontSize: null,
              fontColor: null,
              fontWeight: null,
            },
            html: {
              fontFamily: null,
              lineHeight: null,
              fontSize: null,
              fontColor: null,
              fontWeight: null,
            }
            

          }
        }
      })
    }
  }
  catch (error) {
    theme_ = extendTheme({
      ...defaultTheme, 
      styles: {
        global: {
          body: {
            fontFamily: null,
            lineHeight: null,
            fontSize: null,
            fontColor: null,
            fontWeight: null,
          }
        }
      }
    })
  }

  const [theme, setTheme] = useState(theme_)

  useEffect(() => {
    const updated_theme_string = JSON.stringify(theme)
    localStorage.setItem(`inflowkit-theme-${theme_name}`, updated_theme_string);
  }, [])


  //Default locale is en
  const fetchTheme = () => {
    const config = {
      headers: {
        "Content-Type": "application/json",
        "Cache-Control": "no-cache", // Prevent caching
      },
      withCredentials: true,
    }
    axios
      .get(
        `/a/courses/__themes__/${theme_name}.json`,
        config,
      )
      .then(function (response) {
        if (response.data && response.status === 200 && Object.keys(response.data).length != 0) {

          const updated_theme = extendTheme({
            ...theme_,
            ...response.data,
            styles: {
              global: {
                body: {
                  fontFamily: null,
                  lineHeight: null,
                  fontSize: null,
                  fontColor: null,
                  fontWeight: null,
                }
              }
            }
          });
          ///Save theme to the local storange 
          try {
            const updated_theme_string = JSON.stringify(updated_theme)
            localStorage.setItem(`inflowkit-theme-${theme_name}`, updated_theme_string);

          } catch (error) {
            const updated_theme_string = JSON.stringify(updated_theme)
            localStorage.setItem(`inflowkit-theme-${theme_name}`, updated_theme_string);

          }

          setTheme(() => {
            return updated_theme;
          })

        }
      })
      .catch(function (error) {
        console.log(error)
      })
  }

  return { theme, fetchTheme }
}
export default useThemes
